export const TerminalTypes = ['1/4', '5/16', '3/8', '1/2', 'M6', 'M8', 'M10'];